import { __assign } from "tslib";
import React from 'react';
import { DELETE_ICON } from '@marvelapp/theme';
import { Box, Flex, Icon } from '@marvelapp/ui';
import Button from './Button';
export default function RemoveButton(props) {
    return (React.createElement(Button, __assign({ hoverColor: "red" }, props),
        React.createElement(Flex, { alignItems: "center", px: 1 },
            React.createElement(Icon, { display: "block", height: 16, mr: "3px", paths: DELETE_ICON, width: 16 }),
            React.createElement(Box, { lineHeight: "19px" }, "Remove"))));
}
